<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader
                :step-count="false"
                title="Beneficial Owner - Personal Information"
                :icon="UsersIcon"></WizardHeader>
            <BeneficialOwnerListItem
                class="px-2 py-2"
                :beneficial-owner="currentBeneficialOwner"></BeneficialOwnerListItem>
            <div class="px-4 sm:px-6">
                <AddLegalManagerBeneficialOwnerForm
                    v-model="currentBeneficialOwner"
                    is-beneficial-owner></AddLegalManagerBeneficialOwnerForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :disabled="(formState.currentForm && formState.currentForm.hasValidationErrors) || loading"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_beneficial_owner') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import AddLegalManagerBeneficialOwnerForm from './form/LegalManagerBeneficialOwnerForm.vue'
import { postBeneficialOwner } from '../../../../utilities/api'
import { LegalPerson } from './form/forms'
import BeneficialOwnerListItem from '../../../account/legal/beneficialOwners/BeneficialOwnerListItem.vue'
import { promiseHandler } from '../../../../utilities/helpers'
import { ApiRes } from '../../../../utilities/api'
import { AxiosError } from 'axios'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')
const loading = ref(false)
const currentBeneficialOwner = ref(new LegalPerson())

async function submit() {
    loading.value = true
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        const [data, error] = await promiseHandler<ApiRes, AxiosError>(
            postBeneficialOwner(useLegalAccountDataState().legalProfile.legal_profile_uid, currentBeneficialOwner.value)
        )

        if (data) {
            // currentNewManager.value = response.data
            navigateToNextTab()
        }
    }
    loading.value = false
}
</script>

<style scoped></style>
